import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';

const PrivateRoute = ({ children, roles }) => {
  const { token, user } = useContext(AuthContext);

  // Se non c'è token → login
  if (!token) return <Navigate to="/login" replace />;

  // Controllo ruolo
  const userRole = user?.role;
  const isEnabled=user?.enabled;
  console.log("PrivateRoute user",user);
  console.log("PrivateRoute roles",roles);
  console.log("PrivateRoute userRole",userRole);
  if (roles && roles.length > 0 && (!userRole || !roles.includes(userRole))) {
    return <Navigate to="/forbidden" replace />;
  }
if (!isEnabled) {
  return <Navigate to="/consenso" />;
}
  return children;
};

export default PrivateRoute;
